import { render, staticRenderFns } from "./ClientsApp.vue?vue&type=template&id=1e5c9d10&"
import script from "./ClientsApp.vue?vue&type=script&lang=js&"
export * from "./ClientsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports